module.exports = __webpack_public_path__ + "img/UGTO.db37ee5e.png";